export default __webpack_public_path__ + "static/media/showerbasemiddle.a7873af7.jpg";